define('SageDotCom/Components/Content/IntacctStatus/IntacctStatus',['jquery'], function ($) {
    function IntacctStatus(scope, json, incidentsLabel, incidentLabel, noIncidentsLabel, notApplicableLabel, secondsLabel, monthlyTitleLabel, dailyTitleLabel) {
        $(".intacct-status", scope).attr("data-ux-args", "");
        if (json !== "") {
            var lang = document.documentElement.lang.toLowerCase() || "en-us";
            var jsonItem = JSON.parse(json);
            var dailyTableRowsInit = $(".intacct-status-daily .intacct-status-row");
            dailyTableRowsInit.each(function () {
                var tooltipSpan = $(this).find(".intacct-status-incident span");
                $(tooltipSpan).tooltip();
            });
            $(".intacct-status-dropdown", scope).on("change",
                function () {
                    var selected = $(this).find(":selected").val();
                    const selectedLabel = $(this).find(":selected").prop("label");
                    var dailyTableRows = $(".intacct-status-daily .intacct-status-row");
                    var monthlyChart = $(".intacct-status-monthly .intacct-status-monthly-item");
                    const monthlyTitle = $(".intacct-status-monthly-title");
                    const dailyTitle = $(".intacct-status-daily-title");
                    var tableRowHtml = '<tr class="intacct-status-row">' +
                        '<td class="intacct-status-date"></td>' +
                        '<td class="intacct-status-response"></td>' +
                        '<td class="intacct-status-incident"><span class="disruption"></span></td>' +
                        '</tr>';
                    var graphHtml =
                        "<li class='intacct-status-monthly-item'><span class='intacct-status-uptime'></span><i class='intacct-status-month'></i></li>";
                    $(monthlyTitle).html(selectedLabel + " " + monthlyTitleLabel);
                    $(dailyTitle).html(selectedLabel + " " + dailyTitleLabel);
                    if (selected === "global") {
                        jsonItem.daily_report.overall = jsonItem.daily_report.overall.sort(sortJsonDesc);
                        fillEntireTable(jsonItem.daily_report.overall, dailyTableRows, tableRowHtml);
                        updateMonthChart(jsonItem.monthly_report.overall, monthlyChart, graphHtml);
                    } else {
                        var podDictionary = jsonItem.daily_report.pods;
                        Object.keys(podDictionary).forEach(function (key) {
                            if (key === selected) {
                                podDictionary[key] = podDictionary[key].sort(sortJsonDesc);
                                fillEntireTable(podDictionary[key], dailyTableRows, tableRowHtml);
                            }
                        });

                        var podDictionaryMonth = jsonItem.monthly_report.pods;
                        Object.keys(podDictionaryMonth).forEach(function (key) {
                            if (key === selected) {
                                updateMonthChart(podDictionaryMonth[key], monthlyChart, graphHtml);
                            }
                        });
                    }
                });
        }

        function dateFormat(date, delimiter, isYear) {
            if (isYear) {
                return new Date(date).toLocaleString(lang, { month: 'short', year: 'numeric' });
            } else {
                var formatedDate = new Date(date).toLocaleString(lang, { month: 'short', day: 'numeric' })
                    .toString();
                formatedDate = formatedDate.replace(" ", delimiter);
                return formatedDate;
            }
        }
        function sortJsonDesc(a, b) {
            return new Date(b.date) - new Date(a.date);
        }
        function fillTableRow(item,itemDate,responseTime,numIncidents) {

            const date = $(item).find(".intacct-status-date");
            const response = $(item).find(".intacct-status-response");
            const incidents = $(item).find(".intacct-status-incident");
            
            $(date).html(dateFormat(itemDate, ". ", false));
            if (typeof(responseTime) !== "undefined" && responseTime !== null) {
                $(response).html(responseTime.toFixed(3) + " " + secondsLabel);
            } else {
                $(response).html(notApplicableLabel);
            }
            if (numIncidents > 1) {
                tooltipAndSpanUpdate(incidents, numIncidents, "disruption", " ", incidentsLabel);
            } else if (numIncidents === 1) {
                tooltipAndSpanUpdate(incidents, numIncidents, "disruption", " ", incidentLabel);
            }
            else {
                tooltipAndSpanUpdate(incidents, numIncidents, "normal", "", noIncidentsLabel);
            }

        }
        function updateMonthChartBar(item,uptimePct,date) {
            var uptime = $(item).find(".intacct-status-uptime");
            var month = $(item).find(".intacct-status-month");
            var roundedValue = Math.round(uptimePct * 100) / 100;
            var percentValue = uptimePct + "%";
            $(item).css("height", "calc(200px - (100% - " + percentValue + ") * 50)");
            $(uptime).html(roundedValue);
            $(month).html(dateFormat(date, " ", true));
        }
        function updateMonthChart(item, chart, graphHTML) {
            var numberOfItems = item.length;
            var numberOfCharts = chart.length;
            if (numberOfCharts === numberOfItems) {
                chart.each(function (index) {
                    updateMonthChartBar(this, item[index].uptime_pct,
                        item[index].from);

                });
            } else if (numberOfCharts > numberOfItems) {
                chart.each(function (index) {
                    if (index + 1 <= numberOfItems) {
                        updateMonthChartBar(this, item[index].uptime_pct,
                            item[index].from);
                    } else {
                        $(this).remove();
                    }
                });
            } else {
                var graphContainer = $(scope).find(".bar-graph");
                var chartsToAdd = numberOfItems - numberOfCharts;
                for (var i = 1; i <= chartsToAdd; i++) {
                    $(graphContainer).html($(graphContainer).html() + graphHTML);
                }
                chart = $(".intacct-status-monthly .intacct-status-monthly-item");
                chart.each(function (index) {
                    updateMonthChartBar(this, item[index].uptime_pct,
                        item[index].from);

                });
            }
        }
        function tooltipAndSpanUpdate(incidents,numberOfIncidents,spanClass,delimiter,tooltipText) {
            $(incidents).find("span").tooltip('destroy');
            var spanString =
                '<span class="' + spanClass +'" data-toggle="tooltip" data-placement="bottom" title="' +
                    (numberOfIncidents > 0 ? JSON.stringify(numberOfIncidents) :"")+ delimiter +tooltipText +'"></span>';
            $(incidents).html(spanString);
            $(incidents).find("span").tooltip();
        }
        function fillEntireTable(item, tableRows, tableRowHTML) {
            var numberOfDailyItems = item.length;
            var table = $(scope).find("tbody");
            var difference = 0;
            if (numberOfDailyItems > 15 && tableRows.length === 15) {
                //just fill data
                tableRows.each(function (index) {
                    fillTableRow(this, item[index].date, item[index].response_time_ui_avg_seconds, item[index].num_incidents);
                });
            }
            else if (numberOfDailyItems > 15 && tableRows.length < 15) {
                //add extra rows
                difference = 15 - tableRows.length;
                for (var i = 1; i <= difference; i++) {
                    $(table).html($(table).html() + tableRowHTML);
                }
                tableRows = $(".intacct-status-daily .intacct-status-row");
                tableRows.each(function (index) {
                    fillTableRow(this, item[index].date, item[index].response_time_ui_avg_seconds, item[index].num_incidents);
                });
            } else if (numberOfDailyItems < 15) {

                if (numberOfDailyItems < tableRows.length) {
                    //remove rows
                    difference = tableRows.length - numberOfDailyItems;
                    for (var i = 1; i <= difference; i++) {
                        $(table).find(".intacct-status-row").first().remove();
                    }
                    tableRows = $(".intacct-status-daily .intacct-status-row");
                    tableRows.each(function (index) {
                        fillTableRow(this, item[index].date, item[index].response_time_ui_avg_seconds, item[index].num_incidents);
                    });
                } else if (numberOfDailyItems > tableRows.length) {
                    //add rows
                    difference = numberOfDailyItems - tableRows.length;
                    for (var i = 1; i <= difference; i++) {
                        $(table).html($(table).html() + tableRowHTML);
                    }
                    tableRows = $(".intacct-status-daily .intacct-status-row");
                    tableRows.each(function (index) {
                        fillTableRow(this, item[index].date, item[index].response_time_ui_avg_seconds, item[index].num_incidents);
                    });
                } else {
                    //just fill
                    tableRows.each(function (index) {
                        fillTableRow(this, item[index].date, item[index].response_time_ui_avg_seconds, item[index].num_incidents);
                    });
                }
            }
        }
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null :
            //Pass in json result and all labels needed for rendering the page 
            new IntacctStatus(args.scope, args.json, args.incidentsLabel,
                args.incidentLabel, args.noIncidentsLabel, args.notApplicableLabel,
                args.secondsLabel, args.monthlyTitleLabel, args.dailyTitleLabel);
    }
});
